import { Empty, Failure, Panel } from "../components/Panel.js";
import { useResource } from "../hooks.js";
import { type SessionUser } from "../types.js";

export function UsersPage() {
  const users = useResource<SessionUser[]>("/app/control/user");

  return (
    <Panel title="Users">
      {users.loading ? <Empty>Loading</Empty> : null}
      {users.error ? <Failure>{users.error.message}</Failure> : null}
      {users.value && users.value.length === 0 ? (
        <Empty>No users yet</Empty>
      ) : null}
      {users.value && users.value.length > 0 ? (
        <table className="w-full text-left text-sm">
          <thead className="text-ink/50">
            <tr>
              <th className="pb-2 font-medium">Email</th>
              <th className="pb-2 font-medium">Name</th>
              <th className="pb-2 font-medium">Organizations</th>
            </tr>
          </thead>
          <tbody>
            {users.value.map((user) => (
              <tr key={user.id} className="border-t border-black/5">
                <td className="py-2">{user.email}</td>
                <td className="py-2">{user.name || "—"}</td>
                <td className="py-2 text-ink/60">
                  {user.organizations.length}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </Panel>
  );
}
